import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import '../../styles/AppLoadingOverlay.css';

const MIN_BOOT_TIME = 400;
const MAX_BOOT_TIME = 8000;
const ROUTE_TRANSITION_TIME = 360;

const AppLoadingOverlay = () => {
  const location = useLocation();
  const { loading: authLoading } = useAuth();
  const [booting, setBooting] = useState(true);
  const [timedOut, setTimedOut] = useState(false);
  const [routeChanging, setRouteChanging] = useState(false);
  const [previousKey, setPreviousKey] = useState(location.key);

  useEffect(() => {
    const timer = window.setTimeout(() => setBooting(false), MIN_BOOT_TIME);
    return () => window.clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!authLoading && !booting) return undefined;
    const timer = window.setTimeout(() => setTimedOut(true), MAX_BOOT_TIME);
    return () => window.clearTimeout(timer);
  }, [authLoading, booting]);

  useEffect(() => {
    if (location.key === previousKey) return undefined;

    setPreviousKey(location.key);
    setRouteChanging(true);
    const timer = window.setTimeout(() => setRouteChanging(false), ROUTE_TRANSITION_TIME);
    return () => window.clearTimeout(timer);
  }, [location.key, previousKey]);

  const isPublicAuthPage = ['/login', '/signup', '/accept-invitation', '/psikotes'].some(
    (path) => location.pathname === path || location.pathname.startsWith(`${path}/`)
  );
  const showFullLoader = !isPublicAuthPage && (booting || authLoading);
  const stuck = timedOut && authLoading && !isPublicAuthPage;

  return (
    <>
      <div className={`route-progress ${routeChanging ? 'route-progress--active' : ''}`} aria-hidden="true" />
      {showFullLoader && (
        <div className="app-loading-overlay" role="status" aria-live="polite" aria-label="Memuat aplikasi">
          <div className="app-loading-panel">
            <div className="app-loading-mark" aria-hidden="true">
              <span />
              <span />
              <span />
            </div>
            <div>
              <p className="app-loading-title">{stuck ? 'Koneksi lambat' : 'Memuat workspace'}</p>
              <p className="app-loading-text">
                {stuck ? 'Sesi belum siap. Muat ulang halaman, lalu coba lagi.' : 'Menyiapkan data dan sesi Anda...'}
              </p>
            </div>
            <div className="app-loading-meter" aria-hidden="true">
              <span />
            </div>
            {stuck && (
              <button
                type="button"
                className="app-loading-retry"
                onClick={() => window.location.reload()}
              >
                Muat ulang
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default AppLoadingOverlay;
